export const eventNames = {
  FROM_PLUGIN_EVENT_NAME: "gsPluginEvent",
  TO_PLUGIN_EVENT_NAME: "gsPluginResponseEvent",
} as const;

